export default {
    state: {
        activeChartId: -1,
        activeChartOption: "",
        activeChartType: "",

        firstAnimation: false,
    },
    getters: {},
    mutations: {
        setNewEChartState(state, obj) {
            state[obj.key] = obj.value;
        },
    },
};
